import { useEffect } from "react";

type PageMetaProps = {
  title?: string;
  description?: string;
};

export default function PageMeta({ title, description }: PageMetaProps) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  useEffect(() => {
    if (!description) return;
    const existing = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]'
    );
    if (existing) {
      existing.setAttribute("content", description);
      return;
    }
    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content = description;
    document.head.appendChild(meta);
  }, [description]);

  return null;
}

